import * as React from 'react';

const Checkmark48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M19.17 35 9 24.97l1.063-1.05 9.086 8.973L38.927 13 40 14.039z" }));
Checkmark48.Size = 48;
Checkmark48.Title = "Checkmark";

export { Checkmark48 as default };
